export function getCookie(name) {
  try {
    return document.cookie
      .split('; ')
      .find(row => row.startsWith(name + '='))
      ?.split('=')[1] || null;
  } catch {
    return null;
  }
}

/**
 * Capture Meta attribution:
 *  - fbp: from _fbp cookie (may be null)
 *  - fbc: from fbclid in URL, formatted fb.1.<unix_ts>.<fbclid> (may be null)
 *  - source_url: current page URL
 * Also writes to window.__meta_attribution for easy debugging.
 */
export function getMetaAttribution() {
  const href = typeof window !== 'undefined' ? window.location.href : '';
  let fbc = null;
  try {
    const url = new URL(href);
    const fbclid = url.searchParams.get('fbclid');
    if (fbclid) {
      const ts = Math.floor(Date.now() / 1000);
      fbc = `fb.1.${ts}.${fbclid}`;
    }
  } catch { /* no-op */ }

  const fbp = getCookie('_fbp');
  const source_url = href || null;

  if (typeof window !== 'undefined') {
    window.__meta_attribution = { fbp, fbc, source_url };
  }
  return { fbp, fbc, source_url };
}


